// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ScribbleLine_wrapper__qqStT","line":"ScribbleLine_line__ZO0M0"};